import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';
@Injectable()
export class ContactService {

    constructor(
        private http: HttpClient,
        private global: GlobalDataService
    ) { }

    getContact(isActive:number=-1) {

        let isAvailable: string ="?active="+isActive;

        if(isActive==-1){
            isAvailable="";
        }
        return this.http.get(this.global.httpUrl + "contacts"+isAvailable);
    }

    getContactList() {
        return this.http.get(this.global.httpUrl+"contacts/list?active=1");
    }

   

    getContactByFilter(filter: any[],page:number=0,isActive:number=-1) {
     
        let url = "";

        if(page){
            url = "page="+page + "&";
        }

        for (var item of filter) {
            url += item.name + "=" + item.value + "&";
        }
        url = url.substring(0,url.length-1);

        let isAvailable: string ="?active="+isActive;

        if(isActive==-1){
            isAvailable="";
        }

        return this.http.get(this.global.httpUrl + "contacts?" + url+isAvailable);
    }
    
    getContactListByFilter(filter: any[],page:number=0,isActive:number=-1) {
     
        let url = "";

        if(page){
            url = "page="+page + "&";
        }

        for (var item of filter) {
            url += item.name + "=" + item.value + "&";
        }
        url = url.substring(0,url.length-1);

        let isAvailable: string ="?active="+isActive;

        if(isActive==-1){
            isAvailable="";
        }

        return this.http.get(this.global.httpUrl + "contacts/list?" + url+isAvailable);
    }

    getContactById(id: any) {
        return this.http.get(this.global.httpUrl + "contacts/" + id);
    }

    createContact(data: any) {
        return this.http.post(this.global.httpUrl + "contacts", data);
    }

    updateContact(data: any, id: any) {
        return this.http.put(this.global.httpUrl + "contacts/" + id, data);
    }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/contacts/contact.service.ts